module.exports = __webpack_public_path__ + "media/images/features/refund/icon-step-03-f9a003f10929745d53a4c32ccdd3cfa4.svg";